import { EcmrConsignment } from '@app/shared/models/ecmr/EcmrConsignment';

const isFilled = (v: string | null | undefined): boolean =>
    v != null && v.trim().length > 0;

/** True when the consignment satisfies the Spanish DeCA (FOM/2861/2012) tax-number rules. */
export function isEcmrDcaCompliant(consignment: EcmrConsignment): boolean {
    if (!consignment) return false;

    const senderOk = isFilled(consignment.senderInformation?.taxNumber);
    const carrierOk = isFilled(consignment.carrierInformation?.taxNumber);

    const sc = consignment.successiveCarrierInformation;
    const scOtherFilled =
        isFilled(sc?.successiveCarrierCompanyName) ||
        isFilled(sc?.successiveCarrierDriverName) ||
        isFilled(sc?.successiveCarrierStreet) ||
        isFilled(sc?.successiveCarrierPostcode) ||
        isFilled(sc?.successiveCarrierCity) ||
        isFilled(sc?.successiveCarrierCountryCode?.value) ||
        isFilled(sc?.successiveCarrierCountryCode?.region) ||
        isFilled(sc?.successiveCarrierContactInformation?.email) ||
        isFilled(sc?.successiveCarrierContactInformation?.carrierPhone) ||
        isFilled(sc?.successiveCarrierContactInformation?.driverPhone);
    // Successive carrier is optional; only enforce its tax number if it's actually in use.
    const successiveOk = !scOtherFilled || isFilled(sc?.taxNumber);

    return senderOk && carrierOk && successiveOk;
}
